const ZEC = ({ ...props }) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.0056 20C15.5285 20 20.0056 15.5228 20.0056 10C20.0056 4.47715 15.5285 0 10.0056 0C4.48277 0 0.00561523 4.47715 0.00561523 10C0.00561523 15.5228 4.48277 20 10.0056 20Z"
      fill="#F4B728"
    />
    <path
      d="M6.433 13.1101V14.6362H9.16148V16.3088H10.8385V14.6362H13.567V12.6176H9.33451L13.567 6.87669V5.35052H10.8385V3.68237H9.16148V5.35052H6.433V7.37359H10.6655L6.433 13.1101Z"
      fill="#231F20"
    />
  </svg>
);
export default ZEC;
